import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    num: 0,
  },
  getters: {
    getnum: state => {
      return state.num;
    }
  },
  mutations: {
    change(state, data) {
      state.num = data;
    },
  },
  actions: {
  },
  modules: {
  }
})
